import { render, staticRenderFns } from "./PromoActions.vue?vue&type=template&id=bde7f3c4&"
import script from "./PromoActions.vue?vue&type=script&lang=js&"
export * from "./PromoActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VRow,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4196850391/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bde7f3c4')) {
      api.createRecord('bde7f3c4', component.options)
    } else {
      api.reload('bde7f3c4', component.options)
    }
    module.hot.accept("./PromoActions.vue?vue&type=template&id=bde7f3c4&", function () {
      api.rerender('bde7f3c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PromoActions.vue"
export default component.exports